import { render, staticRenderFns } from "./UserCoupons.vue?vue&type=template&id=50a4c882&scoped=true&"
import script from "./UserCoupons.vue?vue&type=script&lang=js&"
export * from "./UserCoupons.vue?vue&type=script&lang=js&"
import style0 from "./UserCoupons.vue?vue&type=style&index=0&id=50a4c882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a4c882",
  null
  
)

export default component.exports